/**
 * PlaceholderPage — Generic coming-soon page for admin routes not yet fully built.
 *
 * Accepts `title`, `description`, and optional `icon` as props.
 */
import React from 'react';
import { Box, Typography, Card, CardContent, Chip } from '@mui/material';
import { Construction } from '@mui/icons-material';

const PlaceholderPage = ({ title = 'Coming Soon', description, icon }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
    }}
  >
    <Card
      sx={{
        maxWidth: 480,
        textAlign: 'center',
        border: '1px solid #e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Box sx={{ mb: 2, color: '#94a3b8' }}>
          {icon || <Construction sx={{ fontSize: 56 }} />}
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 2 }}>
          {description || 'This module is under development and will be available soon.'}
        </Typography>
        <Chip label="Under Development" color="info" variant="outlined" size="small" />
      </CardContent>
    </Card>
  </Box>
);

export default PlaceholderPage;
